import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ContactFooter from "../ContactFooter";

import ProjectGallery from "./ProjectGallery";
import "./projects.css";
import "./ProjectGallery/projectGallery.css";
import useScrollTo from "../../hooks/useScrollTo";
import { useSelector } from "react-redux";
import ProjectsNavigation from "./ProjectsNavigation";
import ModalPopup from "../ModalPopup";
import Button from "../Shared/Button";
import { useState } from "react";

const Projects = () => {
  const [showModal, setShowModal] = useState(false);
  const currentUser = useSelector((state) => state.user.loggedInUser);

  useScrollTo();

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };
  useScrollTo();

  return (
    <>
      <div className="projects-container">
        <Container fluid>
          <Row>
            <Col xs={12} md={7} style={{ float: "left" }}>
              <h2>Our projects</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={8} style={{ float: "left" }}>
              <p>
                At RIOT Labs, we run many amazing projects, pushing the
                boundaries of technology and human potential. Our diverse
                portfolio spans cutting-edge AI systems, advanced Robotics, and
                immersive VR experiences, each demonstrating our unwavering
                commitment to innovation. As we continue to shape the future, we
                invite you to join us on this journey of technological
                exploration and transformation.
              </p>
              {currentUser && currentUser.level >= 1000 && (
                <Button
                  buttonStyle="pink"
                  text="Create project"
                  onClick={() => handleOpenModal()}
                />
              )}
              <ProjectsNavigation />
            </Col>
          </Row>
          <ProjectGallery />
        </Container>
      </div>
      {showModal && (
        <ModalPopup
          show={handleOpenModal}
          handleClose={handleCloseModal}
          description={"Fill in the form to create the project."}
          title={"Create a project!"}
          image={null}
          type={"createProject"}
        />
      )}
      <ContactFooter />
    </>
  );
};

export default Projects;
